import script from "./UiMenuButtonTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiMenuButtonTrigger.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__